import React, { useState } from 'react';
import {Row, Table, Modal, Button} from 'react-bootstrap';
import {Col} from 'reactstrap';
import './style.css';
import _ from 'lodash';
import Logger from '../../Utils/Logger';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const TimePhasedReportViewer = (props) => {

    const {data} = props;
    const [showModal, setShowModal] = useState(false);
    const [selectedSizeName, setSelectedSizeName] = useState('');
    const [selectedSizeData, setSelectedSizeData] = useState(null);

    const renderReport = (data) => {


        if (data) {
            return _.map(data, (report, index) => {
                return (
                    (
                        <div className={`col mt-2 row-number-${index}`} key={index}>
                            <div className="mt-2">
                                <input type="text" className="form-control text-align-center" value={report.labelOne}
                                       readOnly/>
                            </div>
                            <div className="mt-1">
                                <input type="text" className="form-control text-align-right" value={report.labelTwo}
                                       readOnly/>
                            </div>
                            <div className="mt-1">
                                <input type="text" className="form-control text-align-right" value={report.totalWIP}
                                       readOnly/>
                            </div>
                            <div className="mt-1">
                                <input type="text" className="form-control text-align-right" value={report.totalOrders}
                                       readOnly/>
                            </div>
                            <div className="mt-1 mb-5">
                                <input type="text" className={`form-control text-align-right ${
                                    report.totalAvailable > 0 ? "background-green" : "background-red"
                                }`} value={report.totalAvailable} readOnly/>
                            </div>

                            {_.map(report.sizes, (sizes, sizeIndex) => (
                                <>

                                    <div className={`col mt-2 row-number-${sizeIndex}`}>
                                        <input type="text" className="form-control text-align-right" value={sizes.qty}
                                               readOnly/>
                                    </div>
                                </>
                            ))}
                        </div>
                    )
                )
            })
        }
    }


    const renderOnHand = (data) => {
        if (data) {
            const rangeToGet = data[1];

            return _.map(rangeToGet.sizes, (size, index) => {
                return (
                    <>
                        <div className="col mt-2">
                            <input type="text" className="form-control text-align-right" value={size.onHand} readOnly/>
                        </div>
                    </>
                )
            })
        }
    }


    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedSizeData(null);
        setSelectedSizeName('');
    };

    const handleSizeClick = (sizeIndex, sizeName, reportDataForStyle) => {
        if (!reportDataForStyle || !reportDataForStyle.data || !reportDataForStyle.data[1] || !reportDataForStyle.data[1].sizes[sizeIndex]) {
            Logger.error("Missing data for size modal", { sizeIndex, sizeName, reportDataForStyle });
            return;
        }

        const details = {
            onHand: reportDataForStyle.data[1].sizes[sizeIndex].onHand || 0,
            reports: []
        };

        reportDataForStyle.data.forEach(report => {
            if (report && report.sizes && report.sizes[sizeIndex]) {
                details.reports.push({
                    labelOne: report.labelOne || 'N/A',
                    labelTwo: report.labelTwo || 'N/A',
                    qty: report.sizes[sizeIndex].qty || 0
                });
            }
        });

        setSelectedSizeName(sizeName);
        setSelectedSizeData(details);
        setShowModal(true);
    };


    const renderSizeNames = (data) => {
        if (data && data[1] && data[1].sizes) {
            const sizes = data[1].sizes;
            const reportDataForStyle = data;

            return _.map(sizes, (size, index) => {
                let fontSize = "14px";
                let color = "black";

                if (size.size === "XXS") {
                    fontSize = "10px";
                    color = "lightgray";
                } else if (size.size === "XS") {
                    fontSize = "12px";
                    color = "gray";
                } else if (size.size === "S") {
                    fontSize = "14px";
                    color = "blue";
                } else if (size.size === "M") {
                    fontSize = "16px";
                    color = "green";
                } else if (size.size === "L") {
                    fontSize = "18px";
                    color = "orange";
                } else if (size.size === "XL") {
                    fontSize = "20px";
                    color = "red";
                } else if (size.size === "XXL") {
                    fontSize = "22px";
                    color = "purple";
                }

                return (
                    <div className="size-div clickable" key={index} onClick={() => handleSizeClick(index, size.size, reportDataForStyle)}>
                        <i className="fad fa-tshirt" style={{ fontSize, color }}></i> {size.size}
                    </div>
                );
            })

        }
        return null;
    }


    return (
        <>
            {data ? (

                <>
                    {_.map(data, (reportData, index) => (
                        <div style={{background: "white", width: "98%", margin: "1%"}}>
                            <Col sm={{size: "12"}} className={"style-title"}>
                                <strong>{reportData.style}</strong>
                            </Col>
                            <Col sm={{size: "12"}}>

                                <Row className={"mt-5"}>

                                    <div className="row">

                                        <div className="col-2 margin-top-130">
                                            <div className="col mt-4">ON HAND</div>
                                            <div className="col mt-2 mb-5">
                                                <input type="text"
                                                       className="form-control text-align-right background-green"
                                                       value="100" readOnly/>
                                            </div>
                                            {renderOnHand(reportData.data)}
                                        </div>

                                        <div className="col-1 pr-0">
                                            <div className="col-12 pl-0 pr-0 mb-5">
                                                <div className="margin-top-110">WIP</div>
                                                <div className="margin-top-20">OPEN ORDERS</div>
                                                <div className="margin-top-20 mb-5">AVAILABLE</div>
                                                {renderSizeNames(reportData.data)}
                                            </div>
                                        </div>

                                        {renderReport(reportData.data)}

                                    </div>
                                </Row>

                            </Col>
                        </div>
                    ))}
                </>

            ) : null}

            {selectedSizeData && (
                <Modal show={showModal} onHide={handleCloseModal} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Details for Size: {selectedSizeName}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p><strong>On Hand:</strong> {selectedSizeData.onHand}</p>
                        <hr />
                        <h6>Quantities per Report Period:</h6>
                        <Table striped bordered hover size="sm">
                            <thead>
                                <tr>
                                    <th>Label 1</th>
                                    <th>Label 2</th>
                                    <th>Qty</th>
                                </tr>
                            </thead>
                            <tbody>
                                {selectedSizeData.reports.map((report, idx) => (
                                    <tr key={idx}>
                                        <td>{report.labelOne}</td>
                                        <td>{report.labelTwo}</td>
                                        <td>{report.qty}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseModal}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
        </>
    )
}
export default TimePhasedReportViewer;
